import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatColors } from "@fuse/mat-colors";
import { ErreurService } from "app/main/authentification/erreur.service";
import { EventActionService } from "../../calendar/event-action.service";
import { EventFormComponent } from "../../calendar/event-form/event-form.component";
import { ReservationDialogService } from "./reservation-dialog.service";
import { typeoptions } from "app/global";
import moment from "moment";
import { TranslocoService } from "@ngneat/transloco";
@Component({
  selector: "app-reservation-dialog",
  templateUrl: "./reservation-dialog.component.html",
  styleUrls: ["./reservation-dialog.component.scss"],
  standalone: false,
})
export class ReservationDialogComponent implements OnInit {
  loading = false;

  updated: boolean = null;

  dateTouched = false;

  public reservationDialogRef: MatDialogRef<EventFormComponent> = null;


  typeoptions = typeoptions;

  title: string = "HELLO KRALs";

  reservationForm: UntypedFormGroup;

  presetColors = MatColors.presets;

  reservation;


  constructor(
    private _service: ReservationDialogService,
    private _matDialog: MatDialog,
    private errService: ErreurService,
    public fb: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    public _matDialogRef: MatDialogRef<EventFormComponent>,
    private eventAction: EventActionService,
    public translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public _data: any,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this._service.getReservationTestByEventId(this._data.id).subscribe((res) => {
      this.reservation = res;
    });


  }

  closeThis(): void {
    if (this.updated) {
      this._matDialogRef.close(["save"]);
      this.eventAction.setCalendarAction("save");
      this.updated = false;
    } else this._matDialogRef.close();
  }

  dateTimeChanged(): void {

    this.dateTouched = true;
  }

  initForm(): void {

    this.reservationForm = this.fb.group({
      titre: [this._data.titre, Validators.required],
      debut: [moment(this._data.debut), Validators.required],
      tempsDebut: [new Date(this._data.debut).getHours() +
        ":" +
        new Date(this._data.debut).getMinutes()
      , Validators.required],
      //vehiculeId: [this.event.vehiculeId],
      //color: [this.event.color],
      comment: [null],
      location: [null],
    });

  }

  updateTestReservation(): void {
    this.loading = true;
    const form = this.reservationForm.getRawValue();

    const d = moment(
      moment(form.debut).format("DD/MM/YYYY") + " " + form.tempsDebut,
      "DD/MM/YYYY HH:mm",
    );

    const data = {
      debut: d.format(),
      fin: d.clone().add(1, "hours").format(),
    };

    this._service.updateTestReservation(this._data.id, data).subscribe(() => {
      this.updated = true;
      this.loading = false;

      this.closeThis();
    });


  }

  getCategoryName(category: string): string {
    const option = this.typeoptions[category];
    if (!option) return "";
    return this.translocoService.getActiveLang() === "ar" ? option.optionValue : option.value;
  }

  openEventForm(): void {
    // this.reservationDialogRef = this._matDialog.open(EventFormComponent, {
    //      panelClass: ["common-dialog-style"],
    //     width: "80%",
    //     data: data,
    // });
    // this.reservationDialogRef.componentInstance.title = data.title;
    // this.reservationDialogRef.afterClosed().pipe(take(1)).subscribe((res) => {
    //     //! check if we need to add the confirm shit inside -_-
    //     /* this.setDashAction(res[0]);
    //     this.setCandAction(res[0]);
    //     this.setCalendarAction(res[0]); */
    //     this.reservationDialogRef = null;
    //  });
  }

}
